import React, {useState} from 'react'
import './FeatureCard.css'
import { message } from '../../Helper/svgs'
import { motion } from 'framer-motion'
function FeatureCard(props) {
  
  return (
    <div className={`feature-card card-container ${props.className}`} onMouseOver={props.onMouseOver} onMouseLeave={props.onMouseLeave}>
      <div className="icon">{props.icon}</div>

      <div className="card res-gap-8">
        <span className='title'>
          {props.title}
        </span>

        <p className='content'>
          {props.content}
        </p>
      </div>
    </div>
  )
}

function TestimonialCard(props) {
  const [active, setActive] = useState(false)
  return (
    <motion.div className={`testimonial-card card-container ${active ? 'active' : ''}`} onMouseEnter={()=>setActive(true)} onMouseLeave={()=>setActive(false)} >
      <div className="icon">{message()}</div>

      <div className="card res-gap-16">
        <p className='testimonial text-align-right clr-grey-400 fw-medium fs-regular'>
          {props.testimonial.testimonial}
        </p>
        <div className='container-vertical res-gap-4'>

          <div className='name clr-primary fw-semibold fs-medium text-align-right'>{props.testimonial.name}</div>

          <div className='designation clr-grey-600 fw-regular fs-regular text-align-right'>
            {props.testimonial.designation}
          </div>

        </div>
      </div>

    </motion.div>
  )
}

export { FeatureCard, TestimonialCard }






